"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnFormatterCache = void 0;
const _ = __importStar(require("lodash"));
const ATTRS_TO_COPY = [
    'getCellValue',
    'skipFilter',
    'filterRawData',
    'filterFormattedData',
    'skipExport',
    'exportRawData',
    'exportDataFormatter'
];
function columnFormatterCache(originalFormatter, column) {
    if (column.noFormatterCache) {
        return originalFormatter;
    }
    if (_.isFunction(originalFormatter)) {
        function formatterCache(row, cell, value, columnDef, dataContext, grid) {
            const path = `$$_cache.${column.id}`;
            if (!_.hasIn(dataContext, path)) {
                const result = originalFormatter(row, cell, value, columnDef, dataContext, grid);
                _.set(dataContext, path, result);
                return result;
            }
            return _.get(dataContext, path, '');
        }
        Object.defineProperty(formatterCache, 'name', {
            value: `${column.formatter.name}_cache`,
            writable: false
        });
        for (let attr of ATTRS_TO_COPY) {
            if (_.has(originalFormatter, attr)) {
                Object.defineProperty(formatterCache, attr, {
                    value: _.get(originalFormatter, attr),
                    writable: false
                });
            }
        }
        return formatterCache;
    }
    return originalFormatter;
}
exports.columnFormatterCache = columnFormatterCache;
//# sourceMappingURL=columnFormatterCache.js.map